import React, { useState } from 'react';
import { adminApi } from '../services/api';

interface Props { onLogin: (username: string) => void; }

const LoginPage: React.FC<Props> = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [seedMode, setSeedMode] = useState(false);
  const [seedMsg, setSeedMsg] = useState('');

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const res = await adminApi.login(username, password);
      localStorage.setItem('admin_token', res.token);
      localStorage.setItem('admin_username', res.username);
      onLogin(res.username);
    } catch (err: any) {
      setError(err.message ?? 'Login failed');
    } finally { setLoading(false); }
  };

  const handleSeed = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(''); setSeedMsg(''); setLoading(true);
    try {
      const res = await adminApi.seed(username, password);
      setSeedMsg(res.message + ' — กลับไปเข้าสู่ระบบ');
      setSeedMode(false);
    } catch (err: any) {
      setError(err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="admin-login-shell">
      <div style={{ background: '#fff', borderRadius: 20, padding: 'clamp(24px, 5vw, 40px) clamp(20px, 5vw, 36px)', width: '100%', maxWidth: 380, boxShadow: '0 24px 60px rgba(0,0,0,0.35)' }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ fontSize: 36, marginBottom: 8 }}>☕</div>
          <h1 style={{ fontSize: 22, fontWeight: 700, color: '#1a0f0c' }}>Coffee Admin</h1>
          <p style={{ fontSize: 13, color: '#888', marginTop: 4 }}>{seedMode ? 'สร้าง Admin User ใหม่' : 'เข้าสู่ระบบสำหรับผู้ดูแล'}</p>
        </div>

        {(error || seedMsg) && (
          <div style={{ borderRadius: 10, padding: '10px 14px', marginBottom: 18, fontSize: 13, background: error ? '#fff0f0' : '#f0fff4', color: error ? '#c00' : '#16a34a', border: `1px solid ${error ? '#fca5a5' : '#86efac'}` }}>
            {error || seedMsg}
          </div>
        )}

        <form onSubmit={seedMode ? handleSeed : handleLogin}>
          <div style={{ marginBottom: 14 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#555', marginBottom: 6 }}>Username</label>
            <input
              type="text" value={username} onChange={e => setUsername(e.target.value)} required
              style={inputStyle}
              placeholder="admin"
            />
          </div>
          <div style={{ marginBottom: 22 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#555', marginBottom: 6 }}>Password</label>
            <input
              type="password" value={password} onChange={e => setPassword(e.target.value)} required
              style={inputStyle}
              placeholder="••••••••"
            />
          </div>
          <button type="submit" disabled={loading} style={btnStyle}>
            {loading ? '...' : seedMode ? 'สร้าง Admin' : 'เข้าสู่ระบบ'}
          </button>
        </form>

        <p style={{ textAlign: 'center', marginTop: 18, fontSize: 12, color: '#aaa' }}>
          {seedMode
            ? <span style={{ cursor: 'pointer', color: '#b45309' }} onClick={() => { setSeedMode(false); setError(''); }}>← กลับ Login</span>
            : <span style={{ cursor: 'pointer', color: '#b45309' }} onClick={() => { setSeedMode(true); setError(''); }}>สร้าง Admin User ใหม่</span>
          }
        </p>
      </div>
    </div>
  );
};

const inputStyle: React.CSSProperties = {
  width: '100%',
  padding: '12px 14px',
  borderRadius: 10,
  border: '1.5px solid #e5e7eb',
  fontSize: 16,
  outline: 'none',
  transition: 'border 0.15s',
};
const btnStyle: React.CSSProperties = {
  width: '100%',
  padding: '14px',
  borderRadius: 50,
  border: 'none',
  background: 'linear-gradient(to right, #f59e0b, #d97706)',
  color: '#2a1810',
  fontWeight: 700,
  fontSize: 16,
  minHeight: 48,
  cursor: 'pointer',
  WebkitTapHighlightColor: 'transparent',
  touchAction: 'manipulation',
};

export default LoginPage;
